import { DataVersion, LocationAlarm } from '@hakimo-ui/hakimo/types';
import { withDataVersion } from '@hakimo-ui/hakimo/util';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useSharedLocationAlarm(
  sharedToken: string,
  partitionKey?: string,
  dataVersion?: DataVersion
) {
  const url = `/shared/v2/location_alarm?sharedToken=${sharedToken}${
    partitionKey ? `&partitionKey=${partitionKey}` : ''
  }`;
  const request = new Request(url);
  withDataVersion(request, dataVersion);

  return useAuthenticatedRequest<LocationAlarm>(request, {
    queryKey: [
      'locationAlarms',
      'shared',
      sharedToken,
      partitionKey,
      dataVersion,
    ],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    noAuth: true,
  });
}

export default useSharedLocationAlarm;
